export const SIDEBAR_OPEN = 'SIDEBAR_OPEN'
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE'
// ADD PAGINATION TO CONTEXT LATER
// export const PAGINATION_PREV = 'PAGINATION_PREV'
// export const PAGINATION_NEXT = 'PAGINATION_NEXT'